/**
 * TanStack Query key for portal location / settings.
 * Must match `auth.global` hydration so index redirect can reuse cached portal settings.
 */
export const PORTAL_SETTINGS_QUERY_KEY = ['location', 'portal-settings'] as const
